// extracted by mini-css-extract-plugin
export default {"cls1":"K36obiz53nh1o703WLpI","cls2":"Sl7pEH8Tj_gvighXyH_P K36obiz53nh1o703WLpI"};